<template>
  <div class="building-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="building-content">
      <h4 class="building-h4 indent" id="building-overview">Panoramica</h4>
      <p class="building-p indent">L'alluminio viene utilizzato ai nostri tempi per numerose applicazioni nell'edilizia e nelle grandi costruzioni ed è il materiale preferito per facciate continue, infissi e altre strutture vetrate. Viene ampiamente impiegato per tende avvolgibili, porte, rivestimenti e coperture esterne, controsoffitti, pannelli e pareti divisorie, impianti di riscaldamento e ventilazione, dispositivi di schermatura solare, riflettori di luce e per edifici prefabbricati completi. Strutture come alloggi offshore, ponti per elicotteri, balaustre, ponteggi e scale, sono anch'esse comunemente realizzate in alluminio.</p>
      <p class="building-p indent">In Alcomet produciamo estrusi personalizzati per le vostre necessità ed una vasta gamma di prodotti laminati, come fogli di alluminio, lamiere e nastri per applicazioni edilizie.</p>
      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_1.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-facades">Facciate</h4>
      <p class="building-p indent">Le facciate degli edifici sono uno degli elementi più grandi e importanti per le prestazioni estetiche e tecniche complessive di un edificio. L'alluminio offre agli architetti di nuova generazione la libertà necessaria in termini di design, rispondendo al tempo stesso alle mutevoli preferenze dei consumatori di tutto il mondo. I profili in alluminio e il vetro sono la combinazione perfetta per garantire un alto livello di illuminazione naturale all'interno degli edifici.</p>
      <p class="building-p indent">La facciata continua è un tipo di struttura dell’edificio normalmente realizzato in alluminio, vetro e altri materiali compositi, che forma una struttura molto leggera.</p>
      <p class="building-p indent">Le facciate continue sono utilizzate in tutti i tipi di edifici, con vantaggi che includono rapidità di costruzione, basso costo, peso ridotto e prestazioni elevate. L'alluminio è il materiale più adatto a realizzare l'efficienza energetica nei sistemi di facciate continue, in termini di sfruttamento della luce diurna e riduzione dei costi di raffreddamento degli edifici.</p>
      <p class="building-p indent">Le facciate intelligenti che incorporano sistemi in alluminio possono ridurre il consumo energetico negli edifici fino al 50%. La caratteristica principale di questi edifici intelligenti è la loro interazione ottimizzata con l'esterno, con notevole riduzione del fabbisogno energetico per il riscaldamento, il raffreddamento, la ventilazione e l'illuminazione durante le diverse stagioni.</p>
      <p class="building-p indent">Nel suo impianto di estrusione Alcomet è in grado di estrudere una grande varietà di profili per applicazioni edilizie secondo il vostro progetto. Contattateci oggi stesso con la vostra richiesta.</p>
      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_2.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-wad">Porte e finestre</h4>
      <p class="building-p indent">Le finestre in alluminio offrono molti vantaggi rispetto ad altri prodotti equivalenti: resistenza, facilità di manutenzione, aspetto moderno disponibile in un'infinita gamma di colori, eccellente isolamento acustico sono solo alcuni di essi. Le vetrate in alluminio offrono ai clienti profili minimi e sottili che valorizzano al massimo la vista esterna, ideali per chi desidera sfruttare al meglio il paesaggio rurale.</p>
      <p class="building-p indent">Le finestre in alluminio possono facilmente assicurare miglioramenti in termini di minor perdita di calore, fino al 60% se combinate con un taglio termico, e soddisfano anche i più elevati standard di efficienza energetica, rendendole un elemento preferito nell'architettura moderna.</p>
      <p class="building-p indent">Dalle belle e personalizzate porte scorrevoli per terrazze, alle porte lift and slide, la gamma di porte scorrevoli in alluminio disponibile consente agli architetti di creare un look unico per la vostra proprietà, qualunque sia lo stile dell'edificio. Grazie alla loro combinazione di resistenza e durata, le porte in alluminio possono superare i 3 metri di altezza, lasciando entrare la massima quantità di luce nel vostro edificio.</p>
      <p class="building-p indent">Nel suo impianto di estrusione Alcomet è in grado di estrudere una grande varietà di profili per applicazioni edilizie secondo il vostro progetto. Contattateci oggi stesso con la vostra richiesta.</p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["building-overview", "Panoramica"],
        ["building-facades", "Facciate"],
        ["building-wad", "Porte e finestre"]
      ]
    };
  }
};
</script>

<style scoped>
.building-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.building-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.building-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.building-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.building-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 500px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .building-content {
    width: 100%;
  }
  .building-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .building-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .building-img {
    background-attachment: fixed;
    border-radius: 0;
    min-height: 30vw;
    margin: 20px 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Building.vue